import * as React from "react";
import { ReactElement } from "react";

import { Checkbox, Grid } from "semantic-ui-react";

import { Appointment } from "@teamprevent/common/calendar";

export interface AllTaskTypesListProps {
    blockedTimes: Appointment[];
    selectOrDeselectBlockedTime: (blockedTime: string) => void;
}

const BlockedTimeCheckBox = ({ blockedTimeId, onClick }: { blockedTimeId: string; onClick: (blockedTimeId: string) => void }): ReactElement  => {
    const handleClick = React.useCallback(() => onClick(blockedTimeId), [blockedTimeId, onClick]);
    return <Checkbox onChange={handleClick} />;
};

const BlockedTimeRow = ({
    blockedTime, selectOrDeselectBlockedTime
}: {
    blockedTime: Appointment; selectOrDeselectBlockedTime: (blockedTime: string) => void;
}): ReactElement => (
    <Grid.Row>
        <Grid.Column width={2}>
            <BlockedTimeCheckBox blockedTimeId={blockedTime.id} onClick={selectOrDeselectBlockedTime} />
        </Grid.Column>
        <Grid.Column width={4}>
            Type
            <h3>
                {blockedTime.bookingTypeId}
            </h3>
        </Grid.Column>
        <Grid.Column width={4}>
            Notes
            {blockedTime.description &&
            <p>
                {blockedTime.description}
            </p>}
        </Grid.Column>
        <Grid.Column width={2}>
            Time
            <p>
                {blockedTime.start.format("HH:mm")} - {blockedTime.end.format("HH:mm")}
            </p>
        </Grid.Column>
    </Grid.Row>
);

export const AllAssociatedBlockedTimeList: React.FC<AllTaskTypesListProps> = (props) => (
    <>
        {
            props.blockedTimes
                .sort((a, b) => (a.start > b.start) ? 1 : -1)
                .map((blockedTime) => (<BlockedTimeRow
                    key={blockedTime.id}
                    blockedTime={blockedTime}
                    selectOrDeselectBlockedTime={props.selectOrDeselectBlockedTime}
                />))}
    </>
);
